// ScrollToTop.js

import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop = (props) => {
  const { pathname } = useLocation();
  useEffect(() => {
    document.getElementById('scrollbar')?.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  }, [pathname]);

  return <>{props.children}</>;
};

export default ScrollToTop;
